import { GuidAwareSlideCommand, LayerAwareSlideCommand } from "./slide-commands";
import { ClassroomCommand, CommandType } from "./streaming";


export type VideoCommand = ClassroomCommand & LayerAwareSlideCommand & GuidAwareSlideCommand;

export type LoadVideoCommand = VideoCommand

export type PlayVideoCommand = VideoCommand

export type PauseVideoCommand = VideoCommand

export interface SeekVideoCommand extends VideoCommand {
    commandType: CommandType.SEEK;
    commandParam: "";

    /** new position in seconds */
    seconds: number;

    /**
     * If the player is in paused or play state after seeking to the new position.
     * If a consumer is in a different state when consuming this command,
     * it should pause/play the video accordingly.
     */
    isInPausedState: boolean;
}

export const isVideoCommand = (command: ClassroomCommand): command is VideoCommand =>
    [CommandType.PAUSE, CommandType.PLAY, CommandType.SEEK, CommandType.LOAD].includes(command.commandType);
